import { Box, Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPriceWithAbbr } from '@/shared/utils/formatters';

interface PriceSectionProps {
  unitPrice: number;
  quantity: number;
}

export default function PriceSection({ unitPrice, quantity }: PriceSectionProps) {
  const { t } = useTranslation();

  const formattedUnitPrice = formatPriceWithAbbr(unitPrice);

  const totalPrice = unitPrice * quantity;
  const formattedTotalPrice = formatPriceWithAbbr(totalPrice);

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="column" spacing={2}>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
          >
            {t('offerDetail.price.unitPrice')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {formattedUnitPrice}
          </Typography>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: 'text.secondary',
              mb: 0.5,
            }}
          >
            {t('offerDetail.price.estimatedTotalPrice')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              color: 'primary.main',
            }}
          >
            {formattedTotalPrice}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
